import { motion } from 'framer-motion';

interface FormNavigationButtonProps {
  type: 'previous' | 'continue' | 'submit';
  onClick: () => void;
  disabled?: boolean;
  text?: string;
}

export default function FormNavigationButton({ type, onClick, disabled = false, text }: FormNavigationButtonProps) {
  const isPrevious = type === 'previous';
  const isSubmit = type === 'submit';
  
  const getButtonText = () => {
    if (text) return text;
    if (isSubmit) return 'Submit Application';
    return isPrevious ? 'Previous' : 'Continue';
  };

  const baseClasses = "flex items-center px-6 py-3 rounded-lg font-medium transition-all duration-200 border-2";
  
  const previousClasses = disabled 
    ? 'text-gray-400 border-gray-200 cursor-not-allowed bg-gray-100'
    : 'text-dblue border-dblue hover:bg-dblue hover:text-white bg-white shadow-sm hover:shadow-md';
    
  const continueClasses = 'bg-amber-400 text-dblue font-semibold hover:bg-amber-500 hover:text-white shadow-md hover:shadow-lg border-amber-400 hover:border-amber-500';

  const buttonClasses = isPrevious 
    ? `${baseClasses} ${previousClasses}`
    : `${baseClasses} ${continueClasses} px-8`;

  return (
    <motion.button
      onClick={onClick}
      disabled={disabled}
      className={buttonClasses}
      whileHover={!disabled ? { scale: 1.02 } : {}}
      whileTap={!disabled ? { scale: 0.98 } : {}}
    >
      {isPrevious && (
        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      )}
      <span>{getButtonText()}</span>
      {!isPrevious && (
        <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      )}
    </motion.button>
  );
}

